var UserType;
(function (UserType) {
    UserType["Normal"] = "normal";
    UserType["Server"] = "server";
    UserType["Unknown"] = "unknown";
})(UserType || (UserType = {}));
export default UserType;
//# sourceMappingURL=UserType.js.map